module.exports = __webpack_public_path__ + "static/img/costa2.6d5b491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/costa2.png
// module id = bZJ1
// module chunks = 2